// NPM Imports
import React, { useState, useEffect, useContext } from 'react'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// Component Imports
// JS Imports
// Asset Imports

// Create a shared state object to ensure modal state is consistent across components
const modalState = {
   show: false,
   oldType: 'none',
   setShow: null,
   currentEINIndex: 0,
}

// Custom hook for PayrollImpType modal management
export function usePayrollImpTypeModal() {
   const state = useQuoteContext()
   const { getString } = state

   // Use the shared modalState to control the modal
   const handleShow = (einIndex = 0) => {
      if (state.user_view === 'Internal' && modalState.setShow) {
         modalState.oldType = state.payrollImpType
         modalState.currentEINIndex = einIndex
         modalState.setShow(true)
      }
   }

   // Foundations eligibility modal trigger
   const handleSelfSetupType = (e) => {
      // Check if this EIN already has foundations, if so, skip the modal
      if (
         state.productPayrollEINImpTypes &&
         state.productPayrollEINImpTypes.includes('foundations')
      ) {
         const value = e?.target?.value || 'foundations'

         // Handle the case where this is triggered from a specific EIN row
         if (e?.currentEINIndex !== undefined) {
            state.onProductPayrollImpTypeChange(value, e.currentEINIndex)
         } else {
            state.onProductPayrollImpTypeChange(value, 0)
         }
      } else {
         // Otherwise show the modal to confirm
         if (e?.currentEINIndex !== undefined) {
            handleShow(e.currentEINIndex)
         } else {
            handleShow()
         }
      }
   }

   // If cancel is clicked, set the payroll imp type back to the old type
   const handleCancel = () => {
      state.setPayrollImpType(modalState.oldType)
      if (modalState.setShow) {
         modalState.setShow(false)
      }
   }

   // If continue is clicked, set the payroll imp type to the new type (foundations)
   const handleContinue = () => {
      if (modalState.setShow) {
         modalState.setShow(false)
      }
      state.onProductPayrollImpTypeChange(
         'foundations',
         modalState.currentEINIndex,
      )
   }

   return {
      handleSelfSetupType,
      handleCancel,
      handleContinue,
   }
}

// The actual PayrollImpType Modal component
export default function PayrollImpTypeModal() {
   const state = useQuoteContext()
   const { getString } = state
   const [show, setShow] = useState(false)

   // Register this component's setState with the shared modalState
   useEffect(() => {
      modalState.setShow = setShow
      return () => {
         // Clean up when component unmounts
         if (modalState.setShow === setShow) {
            modalState.setShow = null
         }
      }
   }, [])

   // Keep local state in sync with modalState
   useEffect(() => {
      modalState.show = show
   }, [show])

   const handleClose = () => setShow(false)

   // Get handlers from the hook
   const { handleCancel, handleContinue } = usePayrollImpTypeModal()

   return (
      <Modal
         backdrop='static'
         keyboard={true}
         show={show}
         onHide={handleClose}
         centered
      >
         <Modal.Header>
            <Modal.Title>
               {getString('product.PayrollImpTypeModal.Modal.Title')}
            </Modal.Title>
         </Modal.Header>
         <Modal.Body>
            <div
               dangerouslySetInnerHTML={{
                  __html: getString('product.PayrollImpTypeModal.Modal.Body'),
               }}
            />
         </Modal.Body>
         <Modal.Footer>
            <Button variant='secondary' onClick={handleCancel}>
               {getString('global.Cancel')}
            </Button>
            <Button variant='primary' onClick={handleContinue}>
               {getString('product.PayrollImpTypeModal.Modal.ButtonContinue')}
            </Button>
         </Modal.Footer>
      </Modal>
   )
}
